export const SUPERVISOR_MAX_HOURS_AFTER = 23;
export const MISSION_PLANNER_MIN_HOURS_BEFORE = 2;
export const MISSION_PLANNER_MAX_HOURS_AFTER = 6;
export const TACTICAL_MAX_HOURS_BEFORE = 0;
export const TACTICAL_MAX_HOURS_AFTER = 6;
